import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import Button from '../../../atomic/Buttons/Button';
import HeaderWrapper from '../../FormFields/HeaderWrapper';
import VideoSelect from '../../FormFields/VideoSelect';
import { displayTags } from '../../../../utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px;
`
const HeaderWrapperStyled = styled (HeaderWrapper)`
  background: rgba(0,0,0,0.1);
  margin-bottom: 8px;
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  // background: rgba(0,0,0,0.1);
  margin: 3px;
  margin-bottom: auto;
  flex: 1 0 auto;
  // min-height: 500px;
  width: 450px;
`
const StretchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
`
const Header = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 10px;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  justify-content: center;
  align-items: center;
  ${'' /* height: 100%; */}
  // background: rgba(0,0,0,0.1);
  ${'' /* flex-shrink: 1; */}
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`
const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
`
const OptionSelect = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`
const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 20px;
  flex: 1 0 auto;
`
const NoneStyled = styled.div`
  font-style: italic;
`;

/*
const StepStyled = styled.div`
  padding: 4px;
`
const Step = props => {
  return <StepStyled>{props.num}. {props.step}</StepStyled>;
}
const Steps = props => {
  if (!props.explanation.length) {
    return <NoneStyled>None</NoneStyled>;
  }

  let steps = [];
  const flatExplanation = props.explanation.flat().filter(item => item);
  for (let i = 0; i < flatExplanation.length; i++) {
    steps.push(<Step num={i + 1} step={flatExplanation[i]} />);
  }

  return steps;
}
*/

const ExerciseDetail = ({
  data,
  onEdit,
  allowEdit,
  ...other
}) => {

  const equipment = data.equipment.length ? data.equipment.map(e => e.name).join(', ') : <NoneStyled>None</NoneStyled>;
  const categories = data.categories.length ? data.categories.join(', ') : <NoneStyled>None</NoneStyled>;
  const musclegroup = data.musclegroup.length ? data.musclegroup.map(m => m.name).join(', ') : <NoneStyled>None</NoneStyled>;
  const tags = data.tags.length ? displayTags(data.tags) : <NoneStyled>None</NoneStyled>;

  return (
    <Container>
      <Header>{`Exercise: ${data.name}`}</Header>
      <StretchContainer {...other}>
        {
          (data.video && data.video.length > 0) ? (
          <VideoContainer>
            <OptionWrapper>
              <OptionSelect>
                <VideoSelectStyled
                  thumbnail={data.video[data.video.length - 1].thumbnail}
                  video={data.video[data.video.length - 1].video}
                />
              </OptionSelect>
            </OptionWrapper>
          </VideoContainer>
        ) : (
          <VideoContainer style={{opacity: 0.3}}>
            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
            No Video
          </VideoContainer>
        )}
        <InfoContainer>
          {/*<HeaderWrapperStyled header="Steps">
            <Steps explanation={data.explanation} />
          </HeaderWrapperStyled>*/}
          <HeaderWrapperStyled header="Equipment">
            {equipment}
          </HeaderWrapperStyled>
          <HeaderWrapperStyled header="Categories">
            {categories}
          </HeaderWrapperStyled>
          <HeaderWrapperStyled header="Muscle Groups">
            {musclegroup}
          </HeaderWrapperStyled>
          <HeaderWrapperStyled header="Tags">
            {tags}
          </HeaderWrapperStyled>
          {
            allowEdit &&
            <ButtonContainer>
              <Button variant='outlined' onClick={onEdit}>Edit</Button>
            </ButtonContainer>
          }
        </InfoContainer>
      </StretchContainer>
    </Container>
  )
}

ExerciseDetail.propTypes = {
  data: PropTypes.object,
  allowEdit: PropTypes.bool,
};

ExerciseDetail.defaultProps = {
  allowEdit: true,
}

export default ExerciseDetail;
